import * as React from 'react';
import { FileExtentionIcons } from 'components';

export namespace FileUtils {
    /* eslint-disable-next-line */
    export const getFileExtention = (file_name: string) => {
        return file_name.substring(file_name.lastIndexOf('.') + 1);
    };

    export const getFileIcon = (file_extention: string) => {
        switch (file_extention) {
            case 'doc': return <FileExtentionIcons.DOC />;
            case 'pdf': return <FileExtentionIcons.PDF />;
            case 'ppt': return <FileExtentionIcons.PPT />;
            case 'rar': return <FileExtentionIcons.RAR />;
            case 'rtf': return <FileExtentionIcons.RTF />;
            case 'xls': return <FileExtentionIcons.XLS />;
            case 'zip': return <FileExtentionIcons.ZIP />;

            default: return <FileExtentionIcons.Default />;
        }
    };
}
